import React, { useState } from 'react';

import { GoogleSdkLoader } from '../../../_shared/GoogleSdkLoader';
import { useAuth } from '../../AuthenticationContext';
import { useConfig } from '../../../ConfigContext';

interface Props {
  children?: JSX.Element | JSX.Element[];
}

export function GoogleButton(props: Props): JSX.Element {
  const auth = useAuth();
  const config = useConfig();

  const [isSdkLoaded, setIsSdkLoaded] = useState(false);
  const requiredScopes = ['profile', 'email', 'openid'];

  const onSdkLoaded = (): void => {
    setIsSdkLoaded(true);
  };

  const clickSignIn = async (): Promise<void> => {
    if (!isSdkLoaded) {
      return;
    }

    const authInstance = window.gapi.auth2.getAuthInstance();
    try {
      const user = await authInstance.signIn({
        scope: requiredScopes.join(' '),
        ux_mode: 'popup',
      });

      const profile = user.getBasicProfile();

      await auth.signinWithProvider({
        idToken: user.getAuthResponse().id_token,
      }, 'google', profile.getEmail());
    } catch (e: unknown) {
      const err = e as { error:string };
      if (err.error !== 'popup_closed_by_user') {
        console.error(e);
      }
    }
  };

  return (
    <>
      <button
        type='button'
        id='register-google'
        data-cy='register-google-btn'
        className='btn btn-block btn-outline-light btn-social btn-google'
        title='Google'
        onClick={clickSignIn}
      >
        {props.children}
      </button>
      <GoogleSdkLoader onLoad={onSdkLoaded} clientId={config.serverConfig.providers.google.clientId} />
    </>
  );
}
